var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-nav-item',{staticClass:"nav-item-icon",attrs:{"to":{ name: 'user-profile' },"active":_vm.isActive}},[_c('app-avatar',{class:['my-auto', _vm.isActive ? 'active' : ''],attrs:{"src":_vm.user.avatar_url,"size":"40px"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }